import { injectable } from "inversify";
import StablishmentRepository from "../../../domain/repositories/StablishmentRepository";
import { Either } from "fp-ts/lib/Either";
import ErrorEntity from "../../../domain/entities/ErrorEntity";
import StablishmentEntity from "../../../domain/entities/StablishmentEntity";
import SearchResultEntity from "../../../domain/entities/SearchResultEntity";
import StablishmentRepositoryFake from "./StablishmentRepositoryFake";
import CreateStablishmentApiImpl from "./api/CreateStablishmentApiImpl";
import SearchStablishmentsApiImpl from "./api/SearchStablishmentsApiImpl";
import GetStablishmentByIdApiImpl from "./api/GetStablishmentByIdApiImpl";
import UpdateStablishmentApiImpl from "./api/UpdateStablishmentApiImpl";
import DeleteStablishmentApiImpl from "./api/DeleteStablishmentApiImpl";
import DeleteScheduleApiImpl from "./api/DeleteScheduleApiImpl";
import ScheduleEntity, { ScheduleDay } from "../../../domain/entities/ScheduleEntity";
import GetSchedulesByDateAndStablishmentApiImpl from "./api/GetSchedulesByDateAndStablishmentApiImpl";

@injectable()
export default class StablishmentRepositoryDev implements StablishmentRepository {
    private fakeRepository = new StablishmentRepositoryFake();

    getSchedulesByStablishmentAndDay = async (stablishmentId: string, day: Date): Promise<Either<ErrorEntity, ScheduleEntity[]>> => GetSchedulesByDateAndStablishmentApiImpl(stablishmentId, day);
    
    async deleteSchedule(id: string): Promise<Either<ErrorEntity, void>> {
        try {
            return await DeleteScheduleApiImpl(id);
        } catch (error) {
            return this.fakeRepository.deleteSchedule(id);
        }
    }
    createStablishment = async (stablishment: StablishmentEntity): Promise<Either<ErrorEntity, StablishmentEntity>> => CreateStablishmentApiImpl(stablishment);
    searchStablishments = async (_: {
        query?: string,
        page: number,
        itemsPerPage: number
    }): Promise<Either<ErrorEntity, SearchResultEntity<StablishmentEntity>>> => SearchStablishmentsApiImpl(_);

    getStablishmentById = async (id: string): Promise<Either<ErrorEntity, StablishmentEntity>> => this.fakeRepository.getStablishmentById(id);
    deleteStablishment = async (id: string): Promise<Either<ErrorEntity, void>> => DeleteStablishmentApiImpl(id);
    updateStablishment = async (stablishment: StablishmentEntity): Promise<Either<ErrorEntity, StablishmentEntity>> => UpdateStablishmentApiImpl(stablishment);
}